import React, { useCallback } from 'react';

import { useModalStore } from 'bdvp-common/src/hooks/store';
import { constants as modalConstants } from 'bdvp-graphql/src/resolvers/modals';

import Component from '../components/SearchButton';

const { FILTER_MODAL_NAME } = modalConstants;

const SearchButton = () => {

    const {
        modals,
        modalToggle,
    } = useModalStore();

    const toggleFilterModal = useCallback(() => modalToggle(FILTER_MODAL_NAME), [modalToggle]);

    return (
        <Component
            isActive={modals[FILTER_MODAL_NAME] || false}
            onClick={toggleFilterModal}
        />
    );

};

export default SearchButton;


